import createSmimeDefaultViewState from './createSmimeDefaultViewState';
import isSmimeEnabledInViewState from './isSmimeEnabledInViewState';
import SmimeViewState from '../store/schema/SmimeViewState';
import { lazySmimeAdapter } from 'owa-smime-adapter';
import SmimeType from 'owa-smime-adapter/lib/store/schema/SmimeType';
import smimeStore from 'owa-smime-adapter/lib/store/store';
import { isInitialized } from 'owa-smime-adapter/lib/utils/smimeUtils';
import {
    getSmimeViewStateWithAdminSettings,
    getSmimeViewStateWithUserSettings,
    mergeSmimeViewStates,
} from './smimeViewStateUtil';

export default async function getMergedSmimeViewStateForDraft(
    draftSmimeType: SmimeType
): Promise<SmimeViewState> {
    if (!isInitialized(smimeStore.installationStatus)) {
        /**
         * Initialize S/MIME adapter if we are going to respond with
         * an S/MIME mail.
         */
        await lazySmimeAdapter.import();
    }

    const draftItemSmimeViewState = createSmimeDefaultViewState(draftSmimeType);
    /**
     * S/MIME Admin settings will always be respected in draft but user settings
     * will only be respected when draft is not S/MIME
     */
    return mergeSmimeViewStates([
        getSmimeViewStateWithAdminSettings(),
        isSmimeEnabledInViewState(draftItemSmimeViewState)
            ? draftItemSmimeViewState
            : getSmimeViewStateWithUserSettings(),
    ]);
}
